var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64-Copy",
    transform: "translate(10.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5060004,165.072608 C60.8766671,166.075941 59.0387435,164.939116 55.7767435,169.038783 C51.9920768,161.63745 45.6435932,152.326586 33.4519265,144.516919 C34.428631,141.680363 43.7453639,126.90882 59.7879938,135.605603 C75.8306237,144.302385 66.2156064,158.7192 66.808273,161.290534 L65.5060004,165.072608 Z",
    id: "Fill-1",
    fill: "#FFA076",
    transform: "translate(51.291161, 150.967398) scale(-1, 1) rotate(71.000000) translate(-51.291161, -150.967398) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3711654,210.918976 C8.91888299,203.409853 7.15126217,193.21665 10.9381216,185.207322 C15.9597505,174.58644 30.1450242,169.083029 43.1883402,174.457483 C43.3441147,174.030968 45.039445,169.593027 48.9512971,168.694526 C53.0720923,167.747986 58.2690841,171.047234 59.70137,177.006308 L59.70137,210.918976 L15.3711654,210.918976 Z",
    id: "Stroke-1",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "249.96094 210.894188 271.90439 210.894188 271.90439 171.163295 249.96094 171.163295"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "249.96094 210.894188 271.90439 210.894188 271.90439 171.163295 249.96094 171.163295"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "230.566548 210.894188 252.509998 210.894188 252.509998 164.846033 230.566548 164.846033"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "230.566548 210.894188 252.509998 210.894188 252.509998 164.846033 230.566548 164.846033"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "212.114266 210.894188 234.057716 210.894188 234.057716 128.606308 212.114266 128.606308"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "212.114266 210.894188 234.057716 210.894188 234.057716 128.606308 212.114266 128.606308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5752,67.4305136 L178.866461,99.0156591 L149.766711,98.9624905 C149.766711,98.9624905 145.618866,81.0619483 145.785134,80.5633767 C145.951402,80.064805 162.5752,67.4305136 162.5752,67.4305136",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5752,67.4305136 L178.866461,99.0156591 L149.766711,98.9624905 C149.766711,98.9624905 145.618866,81.0619483 145.785134,80.5633767 C145.951402,80.064805 162.5752,67.4305136 162.5752,67.4305136 Z",
    id: "Stroke-11",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86239142,234.934904 L271.95567,234.934904 C276.104915,234.934904 279.468291,229.630409 279.468291,223.086714 C279.468291,216.543019 276.104915,211.238524 271.95567,211.238524 L7.86239142,211.238524 C3.71337958,211.238524 0.34976972,216.543019 0.34976972,223.086714 C0.34976972,229.630409 3.71337958,234.934904 7.86239142,234.934904 Z",
    id: "Stroke-12",
    stroke: "#1A1A1A",
    strokeWidth: 0.699586078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7762491,72.5031889 C79.0223285,68.3663033 72.894654,63.7222177 73.0383023,56.7925844 C73.4379992,51.4428496 76.1134495,50.5609048 80.1635865,48.4859325 C82.9700927,45.3501545 79.0155658,41.7645426 77.0180143,39.3540022 C74.8234128,36.3751647 74.3022212,32.4947939 74.2329622,28.7953827 C73.8813036,23.5603801 75.7837113,17.8615519 81.6945141,17.4571912 C83.1100099,15.3533026 80.2855477,13.5425407 84.5313356,8.59693348 C88.5527896,3.97686702 97.2122661,-0.619879904 102.654813,3.84884277 C102.654813,3.84884277 109.212732,-3.22070775 116.859675,2.09894479 C124.506617,7.41836413 124.949921,15.8413805 129.937037,15.6196117 C134.924153,15.3978429 137.583979,20.6067277 134.480849,24.1531627 C131.377718,27.6995977 128.717892,27.5888299 128.496356,29.9161196 C128.274588,32.2434093 122.400863,31.5785693 120.849181,30.359424 C119.297732,29.1402787 105.175188,65.4912377 104.423366,65.6017723 C103.671311,65.7127733 83.7762491,72.5031889 83.7762491,72.5031889",
    id: "Fill-13",
    fill: "#25383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7762491,72.5031889 C79.0223285,68.3663033 72.894654,63.7222177 73.0383023,56.7925844 C73.4379992,51.4428496 76.1134495,50.5609048 80.1635865,48.4859325 C82.9700927,45.3501545 79.0155658,41.7645426 77.0180143,39.3540022 C74.8234128,36.3751647 74.3022212,32.4947939 74.2329622,28.7953827 C73.8813036,23.5603801 75.7837113,17.8615519 81.6945141,17.4571912 C83.1100099,15.3533026 80.2855477,13.5425407 84.5313356,8.59693348 C88.5527896,3.97686702 97.2122661,-0.619879904 102.654813,3.84884277 C102.654813,3.84884277 109.212732,-3.22070775 116.859675,2.09894479 C124.506617,7.41836413 124.949921,15.8413805 129.937037,15.6196117 C134.924153,15.3978429 137.583979,20.6067277 134.480849,24.1531627 C131.377718,27.6995977 128.717892,27.5888299 128.496356,29.9161196 C128.274588,32.2434093 122.400863,31.5785693 120.849181,30.359424 C119.297732,29.1402787 105.175188,65.4912377 104.423366,65.6017723 C103.671311,65.7127733 83.7762491,72.5031889 83.7762491,72.5031889 Z",
    id: "Stroke-14",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2024019,71.0197633 C81.2024019,71.0197633 115.756591,45.6534717 137.337189,50.4743194 C158.917787,55.295167 164.569976,68.5942984 164.569976,68.5942984 L149.941165,90.0389436 L151.603381,99.015799 L84.7756544,97.0742144 L81.2024019,71.0197633 Z",
    id: "Fill-15",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2024019,71.0197633 C81.2024019,71.0197633 115.756591,45.6534717 137.337189,50.4743194 C158.917787,55.295167 164.569976,68.5942984 164.569976,68.5942984 L149.941165,90.0389436 L151.603381,99.015799 L84.7756544,97.0742144 L81.2024019,71.0197633 Z",
    id: "Stroke-16",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(87.215064, 16.547543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8843701,28.5253658 C28.8843701,28.5253658 28.6472104,26.6122311 29.4783187,33.3172973 C30.3094269,40.0223634 39.1202472,41.573579 39.2032647,42.768472 C39.2032647,43.9635982 36.2109019,54.7896928 22.5794671,57.3662683 C8.94803241,59.943077 2.79703842,52.8779572 5.2905964,51.7140792 C13.7688801,47.1427505 13.4363435,29.6045939 13.4363435,29.6045939 C13.4363435,29.6045939 6.37122369,26.5289804 5.37384714,18.466484 C-0.444610272,17.4691074 -1.69127266,10.8195418 2.79703842,8.32598379 C4.54250568,7.32860724 6.37122369,7.91042966 6.37122369,7.91042966 C6.37122369,7.91042966 10.4439806,6.91281991 10.1946948,0.0972191453 C21.4988399,2.09197225 26.3196875,3.17259955 31.6393401,0.0972191453 C36.2941526,6.49726578 43.3592724,30.3526847 18.0079053,30.0201481",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8843701,28.5253658 C28.8843701,28.5253658 28.6472104,26.6122311 29.4783187,33.3172973 C30.3094269,40.0223634 39.1202472,41.573579 39.2032647,42.768472 C39.2032647,43.9635982 36.2109019,54.7896928 22.5794671,57.3662683 C8.94803241,59.943077 2.79703842,52.8779572 5.2905964,51.7140792 C13.7688801,47.1427505 13.4363435,29.6045939 13.4363435,29.6045939 C13.4363435,29.6045939 6.37122369,26.5289804 5.37384714,18.466484 C-0.444610272,17.4691074 -1.69127266,10.8195418 2.79703842,8.32598379 C4.54250568,7.32860724 6.37122369,7.91042966 6.37122369,7.91042966 C6.37122369,7.91042966 10.4439806,6.91281991 10.1946948,0.0972191453 C21.4988399,2.09197225 26.3196875,3.17259955 31.6393401,0.0972191453 C36.2941526,6.49726578 43.3592724,30.3526847 18.0079053,30.0201481",
    id: "Stroke-18",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    points: "54.0215706 210.894188 215.937737 210.894188 215.937737 97.0740978 54.0215706 97.0740978"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-21",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "54.0215706 210.894188 215.937737 210.894188 215.937737 97.0740978 54.0215706 97.0740978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2825628,97.0740978 L98.9336443,97.0740978 C98.9336443,97.0740978 85.4129773,113.525564 84.858672,121.726812 C84.3045998,129.927826 85.1434035,136.294059 93.4792048,137.93179 C86.6318895,141.010435 79.3174838,135.469014 78.6526439,133.474261 C77.9875707,131.479275 81.5340057,104.181892 82.4206145,103.368041 C83.3072232,102.553956 94.2825628,97.0740978 94.2825628,97.0740978",
    id: "Fill-22",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "67.4312365 177.75736 74.8566432 177.75736 74.8566432 171.994403 67.4312365 171.994403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-24",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "67.4312365 177.75736 74.8566432 177.75736 74.8566432 171.994403 67.4312365 171.994403"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FFFFFF",
    points: "67.4312365 189.726345 74.8566432 189.726345 74.8566432 183.963388 67.4312365 183.963388"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-26",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "67.4312365 189.726345 74.8566432 189.726345 74.8566432 183.963388 67.4312365 183.963388"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#FFFFFF",
    points: "67.4312365 201.695797 74.8566432 201.695797 74.8566432 195.93284 67.4312365 195.93284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-28",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "67.4312365 201.695797 74.8566432 201.695797 74.8566432 195.93284 67.4312365 195.93284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#FFFFFF",
    points: "84.7194077 176.094911 202.598029 176.094911 202.598029 173.65662 84.7194077 173.65662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-30",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "84.7194077 176.094911 202.598029 176.094911 202.598029 173.65662 84.7194077 173.65662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FFFFFF",
    points: "84.7194077 188.064129 202.598029 188.064129 202.598029 185.626071 84.7194077 185.626071"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-32",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "84.7194077 188.064129 202.598029 188.064129 202.598029 185.626071 84.7194077 185.626071"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#FFFFFF",
    points: "84.7194077 199.589809 202.598029 199.589809 202.598029 197.032589 84.7194077 197.032589"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-34",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "84.7194077 199.589809 202.598029 199.589809 202.598029 197.032589 84.7194077 197.032589"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#FFFFFF",
    points: "152.10214 165.677374 165.401271 165.677374 165.401271 151.048563 152.10214 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-36",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "152.10214 165.677374 165.401271 165.677374 165.401271 151.048563 152.10214 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#FFFFFF",
    points: "172.402962 165.677374 183.687518 165.677374 183.687518 151.048563 172.402962 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-38",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "172.402962 165.677374 183.687518 165.677374 183.687518 151.048563 172.402962 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#FFFFFF",
    points: "190.170816 165.677374 201.474961 165.677374 201.474961 151.048563 190.170816 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-40",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "190.170816 165.677374 201.474961 165.677374 201.474961 151.048563 190.170816 151.048563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#FFFFFF",
    points: "153.284207 141.738938 197.152685 141.738938 197.152685 104.83414 153.284207 104.83414"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-42",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "153.284207 141.738938 197.152685 141.738938 197.152685 104.83414 153.284207 104.83414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2843,104.83421 C153.2843,105.435387 197.152778,141.739008 197.152778,141.739008",
    id: "Stroke-43",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 2.798344387727625
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.2843,
    y1: 141.738984,
    x2: 197.125028,
    y2: 105.324596,
    id: "Stroke-44",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 2.798344387727625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3805865,108.381787 C86.7742786,109.557092 86.2216056,110.690188 85.7202355,111.781776 C67.1229056,116.142296 60.117717,108.064642 57.6901533,103.368087 C65.2503469,87.349898 75.4666356,74.6615053 75.4666356,74.6615053 C77.3228706,72.2948056 85.1628986,66.8214773 93.1428438,74.4679531 C101.122789,82.114429 100.124713,89.3180668 87.3805865,108.381787",
    id: "Fill-45",
    fill: "#146E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3805865,108.381787 C86.7742786,109.557092 86.2216056,110.690188 85.7202355,111.781776 C67.1229056,116.142296 60.117717,108.064642 57.6901533,103.368087 C65.2503469,87.349898 75.4666356,74.6615053 75.4666356,74.6615053 C77.3228706,72.2948056 85.1628986,66.8214773 93.1428438,74.4679531 C101.122789,82.114429 100.124713,89.3180668 87.3805865,108.381787 Z",
    id: "Stroke-46",
    stroke: "#146E6E",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5338658,161.162292 C73.5338658,161.162292 93.7248528,165.170221 109.572809,152.868699 C121.000082,143.180132 122.0961,140.954982 122.0961,140.954982 L124.645158,139.4588 C124.645158,139.4588 126.362875,140.788713 129.244237,141.287285 C132.125832,141.78609 133.289477,140.289908 133.289477,140.289908 C133.289477,140.289908 125.088463,135.856865 124.589658,135.74633 C124.091086,135.635329 98.3241649,145.609794 97.82536,146.108366 C97.3265551,146.607171 80.4812219,158.631423 80.4812219,158.631423 L73.5338658,161.162292 Z",
    id: "Fill-47",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76621,128.522684 C150.107783,130.934157 139.38546,126.111444 139.38546,126.111444 C139.38546,126.111444 142.876395,138.829919 138.552953,141.241159 C134.231843,143.650067 124.838734,137.750224 124.838734,137.750224 L122.180307,139.245007 C110.210389,155.536268 67.6293826,174.989658 53.0238909,147.724223 C45.5434501,133.759552 50.9111409,117.725739 57.69013,103.368134 C60.1176937,108.064455 67.1228823,116.142342 85.7202122,111.781822 C70.3712937,145.180062 103.125914,140.138378 115.280056,131.848283 C127.83063,123.287681 135.395254,120.0451 144.455594,122.622142 C147.452854,123.474937 155.426969,126.111444 152.76621,128.522684",
    id: "Fill-48",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76621,128.522684 C150.107783,130.934157 139.38546,126.111444 139.38546,126.111444 C139.38546,126.111444 142.876395,138.829919 138.552953,141.241159 C134.231843,143.650067 124.838734,137.750224 124.838734,137.750224 L122.180307,139.245007 C110.210389,155.536268 67.6293826,174.989658 53.0238909,147.724223 C45.5434501,133.759552 50.9111409,117.725739 57.69013,103.368134 C60.1176937,108.064455 67.1228823,116.142342 85.7202122,111.781822 C70.3712937,145.180062 103.125914,140.138378 115.280056,131.848283 C127.83063,123.287681 135.395254,120.0451 144.455594,122.622142 C147.452854,123.474937 155.426969,126.111444 152.76621,128.522684 Z",
    id: "Stroke-49",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4484,89.9557162 C179.4484,89.9557162 169.557185,95.7741736 173.214388,99.4313764 C176.871591,103.088579 180.224241,97.5751414 183.133353,98.7387862 C186.042465,99.9024311 179.946971,107.327605 182.939334,108.740768 C185.931697,110.153699 196.321483,107.161336 198.482738,106.496496 C200.643759,105.831656 204.880452,99.51556 201.059313,90.9530928 C196.570769,80.8956101 179.4484,89.9557162 179.4484,89.9557162",
    id: "Fill-50",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4484,89.9557162 C179.4484,89.9557162 169.557185,95.7741736 173.214388,99.4313764 C176.871591,103.088579 180.224241,97.5751414 183.133353,98.7387862 C186.042465,99.9024311 179.946971,107.327605 182.939334,108.740768 C185.931697,110.153699 196.321483,107.161336 198.482738,106.496496 C200.643759,105.831656 204.880452,99.51556 201.059313,90.9530928 C196.570769,80.8956101 179.4484,89.9557162 179.4484,89.9557162 Z",
    id: "Stroke-51",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#1A1A1A",
    points: "215.937667 128.606261 218.015671 128.606261 221.174302 137.962759 221.174302 210.894141 215.937667 210.894141"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#1A1A1A",
    points: "234.057669 164.846056 235.585798 164.846056 237.908891 170.157547 237.908891 211.559051 234.057669 211.559051"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#1A1A1A",
    points: "252.510068 171.163272 254.038431 171.163272 256.36129 175.756288 256.36129 211.559237 252.510068 211.559237"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.10214,
    y1: 151.048353,
    x2: 165.401271,
    y2: 165.677164,
    id: "Stroke-55",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.401224,
    y1: 151.048353,
    x2: 152.102093,
    y2: 165.677164,
    id: "Stroke-56",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.687472,
    y1: 151.048353,
    x2: 172.402915,
    y2: 165.677164,
    id: "Stroke-57",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.403008,
    y1: 151.048353,
    x2: 183.687565,
    y2: 165.677164,
    id: "Stroke-58",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.465096,
    y1: 151.048353,
    x2: 190.18054,
    y2: 165.677164,
    id: "Stroke-59",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.180633,
    y1: 151.048353,
    x2: 201.46519,
    y2: 165.677164,
    id: "Stroke-60",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.277864,46.5394741 C107.277864,46.5394741 113.97127,48.0277269 116.173801,46.9263452 L115.966023,44.869329 C113.984562,45.8049088 110.969813,46.4632193 107.277864,46.5394741",
    id: "Fill-61",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#1A1A1A",
    points: "133.732781 97.0740978 150.931406 95.387629 151.243887 97.0740978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.272652,76.1220311 C122.220883,82.730088 122.50095,88.3197808 122.096123,88.5900542",
    id: "Stroke-63",
    stroke: "#1A1A1A",
    strokeWidth: 0.588235294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEmpty);
export default __webpack_public_path__ + "static/media/order_empty.80aba3ab.svg";
export { ForwardRef as ReactComponent };